import "./Skills.css"
import Image1 from "../../assets/service-1.svg";
import Image2 from "../../assets/service-2.svg";
import Image3 from "../../assets/service-3.svg";

const data = [
  {
    id: 1,
    image: Image1,
    title: "Languages",
    description:
      "Python, C++, TypeScript, JavaScript, Java, Go, SQL.",
  },
  {
    id: 2,
    image: Image2,
    title: "Front End/Frameworks",
    description:
      "React, React Native, HTML, CSS, Redux, Next.js, Tailwind CSS, Sass, Bootstrap.",
  },
  {
    id: 3,
    image: Image3,
    title: "Back End/Tools",
    description:
      "Node.js, Express.js, FastAPI, Django, Google Cloud, PostgreSQL, MongoDB, Git/GitHub, Docker, Postman, Vitest, Testify.",
  },
];

const Skills = () => {
  return (
    <section className="services container section" id="skills">
      <h2 className="section__title">
        Skills
      </h2>

      <div className="services__container grid">
        {data.map(({id, image, title, description}) => {
          return (
            <div className="service__card" key={id}>
              <img 
                src={image}
                alt={title}
                className="service__img"
              />

              <h3 className="service__title">
                {title}
              </h3>

              <p className="service__description">
                {description}
              </p>
            </div>
          )
        })}
      </div>
    </section>
  );
}

export default Skills